import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";
import Accepted from "../../components/Wallet/Accepted";
import Rejected from "../../components/Wallet/Rejected";
import Requested from "../../components/Wallet/Requested";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import WalletRejectedList from "./WalletRejectedList";
import { checkPermission } from "../redux/api/PermissionManager";

const WalletTransaction = () => {
  const location = useLocation();
  const { paginationData, setpaginationData } = useGlobalContext();
  const path = location.pathname?.replace("/", "");
  const [totalCount, setTotalCount] = useState();

  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [search, setSearch] = useState(paginationData?.[path]?.search ?? "");
  const [pagination, setPagination] = useState("");
  const [isReject, setIsReject] = useState(null);
  const [locationList, setLocationsList] = useState({ states: [], cities: [] });
  const [isUserDropdownList, setuserDropdownList] = useState([]);
  const [owners, setOwners] = useState([]);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [activeStatus, setActiveStatus] = useState(
    paginationData?.[path]?.tab ?? 0,
  );
  const [isfailedowners, setIsFailedOwners] = useState([]);

  const [popup, setpopup] = useState(false);
  const [isUpdate, setIsUpdate] = useState();
  const [isRejectList, setIsRejectList] = useState({
    isViewList: false,
    data: "",
    ticket_id: "",
  });
  const [filters, setFilters] = useState({
    user_id: null,
    state: null,
    city: null,
  });
  const [isSelectAll, setIsSelectAll] = useState({
    selectValue: false,
    wallet_ids: [],
  });

  const toggleSelectAll = () => {
    setIsSelectAll((prev) => ({
      ...prev,
      selectValue: !isSelectAll.selectValue,
    }));
    // const allSelected = owners.every((o) => o.selected);
    // setOwners(owners.map((o) => ({ ...o, selected: !allSelected })));
  };
  console.log("location.state?.type", location.state?.type);
  useEffect(() => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], tab: activeStatus },
    }));
  }, [activeStatus]);

  const fetch = async () => {
    try {
      const payload = {
        page: page,
        search: search,
        status: activeStatus, // Use activeStatus instead of hardcoded 1
        user_id: filters.user_id?.value,
        state_id: filters.state,
        city_id: filters.city,
      };

      // Remove empty/null values from payload
      const cleanedPayload = Object.entries(payload).reduce(
        (acc, [key, value]) => {
          if (value !== "" && value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        },
        {},
      );

      const res = await post(
        `${URLS.USER_WALLET_LIST}?page=${page}`,
        cleanedPayload,
      );
      console.log("res admin list", res);
      setTotalCount(res?.count);

      if (!res || Object.keys(res).length === 0) {
        // setOwners([]);
      } else {
        console.log("owner response success", res);
        setPagination({
          current_page: page,
          last_page: res?.next ? page + 1 : page,
        });
        setOwners(res?.data || []);
      }
    } catch (err) {
      console.log("err", err);
      // setOwners([]);
    }
  };

  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${
      parent_id ? `&parent_id=${parent_id}` : ""
    }`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      if (type === 2)
        setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      else if (type === 3)
        setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };
  const userDropdownListGET = useCallback(async (locationType, parent_id) => {
    try {
      const url = `${URLS.USERLIST_DROPDOWN}`;
      const res = await get(url);

      if (res?.status === "success") {
        const formatted = res?.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setuserDropdownList(formatted);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  }, []);
  useEffect(() => {
    getLocationsList(2);
    userDropdownListGET();
  }, []);

  useEffect(() => {
    if (!isRejectList?.isViewList) {
      fetch();
    }
  }, [
    page,
    search,
    filters.user_id,
    filters.city,
    filters.state,
    activeStatus,
    location.state,
    isRejectList?.isViewList,
  ]);

  // Handle Select All checkbox
  const handleSelectAll = () => {
    const newSelectValue = !isSelectAll.selectValue;

    setIsSelectAll({
      selectValue: newSelectValue,
      wallet_ids: newSelectValue ? owners.map((owner) => owner.id) : [],
    });

    // Update all owners' selected status
    setOwners(
      owners.map((owner) => ({
        ...owner,
        selected: newSelectValue,
      })),
    );
  };

  const handleCheckboxToggle = (id) => {
    setOwners((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, selected: !item.selected } : item,
      ),
    );

    console.log("OSD", id, owners);
  };

  const accept = async () => {
    let update = owners.filter((ele) => ele?.selected == true);
    if (update.length == 0) {
      toast.error("Kindly choose a Wallet ID");
      return;
    }
    console.log("OWNER_accept", update.length);
    try {
      const payload = {
        wallet_ids: update.map((ele) => ele?.id),
      };
      console.log("UADSDPSADP", payload);

      const res = await post(`${URLS.USER_WALLET_ACCEPT}`, payload);
      //   console.log("res admin list", res);
      if (res.status == "success") {
        toast.success("Accept All User");
        setActiveStatus(1); // This will trigger fetch via useEffect
      }
    } catch (err) {
      console.log("err", err);
      // setOwners([]);
    }
  };
  const reject = async () => {
    // console.log("OWNERrejectRRLIST", owners);
    let update = owners.filter((ele) => ele?.selected == true);
    if (update.length == 0) {
      toast.error("Kindly choose a Wallet ID");
      return;
    }
    if (isReject == null) {
      toast.error("Kindly added a Reject Reason");
      return;
    }
    console.log("OWNER_accept", update.length);
    try {
      const payload = {
        wallet_ids: update.map((ele) => ele?.id),
        reason: isReject,
      };
      console.log("UADSDPSADP", payload);

      const res = await post(`${URLS.USER_WALLET_REJECT}`, payload);
      //   console.log("res admin list", res);
      if (res.status == "success") {
        toast.success("Reject The User");
        setIsReject(null);
        setpopup(false);
        setActiveStatus(5); // This will trigger fetch via useEffect
      }
    } catch (err) {
      console.log("err", err);
      // setOwners([]);
    }
  };
  const reSend = async ({ id }) => {
    try {
      console.log("ISDOJADJKSADa", id, isUpdate);
      const payload = {
        wallet_id: id,
      };
      console.log("UADSDPSADPshkjdahkjsahdjkahkjd", payload);

      const res = await post(`${URLS.USER_WALLET_RESEND}`, payload);
      //   console.log("res admin list", res);
      if (res.status == "success") {
        setActiveStatus(0); // This will trigger fetch via useEffect
      }
    } catch (err) {
      console.log("err", err);
      // setOwners([]);
    }
  };
  const rejectListView = async (pageNum = 1, pageSize = 10) => {
    const queryParams = {
      admin_transaction_id: isRejectList?.data,
      search: search,
      page: "",
      page_size: "",
    };

    // Remove null/undefined values
    const filteredParams = Object.fromEntries(
      Object.entries(queryParams).filter(([_, v]) => v != null && v !== ""),
    );

    // Construct URL with filtered params
    const params = new URLSearchParams(filteredParams).toString();
    let url = `${URLS.REJECTLISTVIEW}?${params}`;

    // let url = `${URLS.REJECTLISTVIEW}?admin_transaction_id=${isRejectList?.data}&search=${search}`;
    const res = await get(url);
    console.log("AJDSJASD", res);
    if (res?.status === "success") {
      setTotalCount(res?.count || 0);
      setPagination({
        current_page: pageNum,
        last_page: res?.next ? pageNum + 1 : pageNum,
      });
      setIsFailedOwners(res?.data);
      //   const modifiedList = res.data.map((item) => ({
      //     value: item.id,
      //     label: item.name,
      //   }));
      //   // if (type === 2)
      //   //   setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      //   // else if (type === 3)
      //   //   setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };
  useEffect(() => {
    if (isRejectList?.isViewList) {
      rejectListView();
    }
  }, [isRejectList, search]);
  console.log("totalCount", totalCount);

  return (
    <div>
      <Topbar header={"Wallet Transaction"} subHead={"User"} />
      <div
        className="d-flex"
        style={{ flexDirection: "row", justifyContent: "space-between" }}
      >
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total: {totalCount || 0}
        </h2>

        {checkPermission("CAN-ADD-WALLETUSER") && activeStatus === 0 && (
          <button
            onClick={() =>
              navigate("/wallettransactionadd", {
                state: { type: "add" },
              })
            }
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            Add
          </button>
        )}
      </div>

      {isRejectList?.isViewList ? (
        <>
          <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
            <div className="d-flex gap-3">
              <button
                onClick={() => {
                  setPage(1);

                  setActiveStatus(0);
                  setIsRejectList({
                    isViewList: false,
                    data: "",
                    ticket_id: "",
                  });
                }}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 0 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Requested
              </button>

              <button
                onClick={() => {
                  setPage(1);

                  setActiveStatus(1);
                  setIsRejectList({
                    isViewList: false,
                    data: "",
                    ticket_id: "",
                  });
                }}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 1 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Accepted
              </button>

              <button
                onClick={() => {
                  setPage(1);

                  setActiveStatus(5);
                  setIsRejectList({
                    isViewList: false,
                    data: "",
                    ticket_id: "",
                  });
                }}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 5 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Rejected
              </button>
            </div>
            <div className="d-flex gap-3">
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Search UserName"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1); // Reset to first page on search
                  }}
                  style={{ border: "none", width: "150px" }}
                />
                <img src={Search_icon} className="search" alt="search" />
              </div>
            </div>
          </div>

          {activeStatus === 0 && checkPermission("CAN-EDIT-WALLETUSER") && (
            <div
              className="d-flex ae-je gap-3 my-3"
              style={{ alignItems: "center" }}
            >
              <input
                type="checkbox"
                style={{ width: 19, height: 22 }}
                onClick={handleSelectAll}
              />
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 select-btn"
                onClick={handleSelectAll}
              >
                Select All
              </button>
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 accept-btn"
                onClick={accept}
              >
                Accept All
              </button>
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 reject-btn"
                onClick={() => {
                  const selectedItems = owners.filter(
                    (ele) => ele?.selected === true,
                  );
                  if (selectedItems.length > 0) {
                    setpopup(true);
                  } else {
                    toast.error("Kindly choose a Wallet ID");
                  }
                }}
              >
                Reject All
              </button>
            </div>
          )}

          {
            <WalletRejectedList
              isRejectList={isRejectList}
              ownersList={isfailedowners}
              pagination={pagination}
              page={page}
              setPage={setPage}
            />
          }
        </>
      ) : (
        <>
          <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
            <div className="d-flex gap-3">
              <button
                onClick={() => {
                  setActiveStatus(0);
                  setIsRejectList({
                    isViewList: false,
                    data: "",
                    ticket_id: "",
                  });
                  setPage(1);
                }}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 0 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Requested
              </button>

              <button
                onClick={() => {
                  setActiveStatus(1);
                  setIsRejectList({
                    isViewList: false,
                    data: "",
                    ticket_id: "",
                  });
                  setPage(1);
                }}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 1 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Accepted
              </button>

              <button
                onClick={() => {
                  setActiveStatus(5);
                  setIsRejectList({
                    isViewList: false,
                    data: "",
                    ticket_id: "",
                  });
                  setPage(1);
                }}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 5 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Rejected
              </button>
            </div>
            <div className="d-flex gap-3">
              <Select
                className="location-search"
                options={locationList?.states}
                value={state}
                onChange={(selected) => {
                  setLocationsList((prev) => ({ ...prev, cities: [] }));
                  setFilters((prev) => ({
                    ...prev,
                    state: selected?.value || null,
                    city: null,
                  }));
                  if (selected?.value) getLocationsList(3, selected.value);
                  setState(selected);
                  setCity(null);
                  setPage(1);
                }}
                isClearable
                placeholder={"State"}
              />

              <Select
                className="location-search"
                options={locationList?.cities}
                value={city}
                onChange={(selected) => {
                  setFilters((prev) => ({
                    ...prev,
                    city: selected?.value || null,
                  }));
                  setCity(selected);
                  setPage(1);
                }}
                isClearable
                placeholder={"City"}
              />
              <Select
                className="location-search"
                options={isUserDropdownList}
                value={filters.user_id}
                onChange={(selected) => {
                  setFilters((prev) => ({ ...prev, user_id: selected }));
                  setPage(1);
                }}
                placeholder={"User ID"}
              />
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Search User Name"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1); // Reset to first page on search
                  }}
                  style={{ border: "none", width: "150px" }}
                />
                <img src={Search_icon} className="search" alt="search" />
              </div>
            </div>
          </div>

          {activeStatus === 0 && checkPermission("CAN-EDIT-WALLETUSER") && (
            <div
              className="d-flex ae-je gap-3 my-3"
              style={{ alignItems: "center" }}
            >
              <input
                type="checkbox"
                style={{ width: 19, height: 22 }}
                onClick={handleSelectAll}
              />
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 select-btn"
                onClick={handleSelectAll}
              >
                Select All
              </button>
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 accept-btn"
                onClick={accept}
              >
                Accept All
              </button>
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 reject-btn"
                onClick={() => {
                  const selectedItems = owners.filter(
                    (ele) => ele?.selected === true,
                  );
                  if (selectedItems.length > 0) {
                    setpopup(true);
                  } else {
                    toast.error("Kindly choose a Wallet ID");
                  }
                }}
              >
                Reject All
              </button>
            </div>
          )}

          {activeStatus === 0 && (
            <Requested
              isSelectAll={isSelectAll}
              setIsSelectAll={setIsSelectAll}
              ownersList={owners}
              handleCheckboxToggle={handleCheckboxToggle}
              pagination={pagination}
              page={page}
              setPage={setPage}
            />
          )}
          {activeStatus === 1 && (
            <Accepted
              ownersList={owners}
              pagination={pagination}
              page={page}
              setPage={setPage}
            />
          )}
          {activeStatus === 5 && (
            <Rejected
              ownersList={owners}
              pagination={pagination}
              reSend={reSend}
              setIsUpdate={setIsUpdate}
              setIsRejectList={setIsRejectList}
              page={page}
              setPage={setPage}
            />
          )}
          {popup && (
            <div className="img-popup-design">
              <div className="img-popup">
                <h2
                  className="f4 mt-4"
                  style={{ width: "100%", textAlign: "left" }}
                >
                  Wallet Transaction
                </h2>
                <p
                  className="f3 mt-4"
                  style={{ width: "100%", textAlign: "left" }}
                >
                  Are you sure you want to Reject?
                </p>
                <textarea
                  className=" mt-3"
                  value={isReject}
                  onChange={(e) => setIsReject(e.target.value)}
                  placeholder="Reject Reason"
                  style={{ width: "100%", textAlign: "left", height: "120px" }}
                />
                <div className="d-flex ac-jb px-2 mt-2">
                  <button onClick={() => reject()} className="add-btn w-40">
                    Yes
                  </button>
                  <button
                    onClick={() => setpopup(!popup)}
                    className="reject-btn w-40"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WalletTransaction;
